import React from 'react'
import {useTranslation} from 'i18n'
import {Paragraph, RoboyuConfused} from 'common/components'
import convertUnit from 'lib/unit'
import {useSelector} from 'lib/redux'
import {GiftShopRobopetActivationTemplate} from '../ActivationTemplate'

// const StyledButton = styled(Button)`
//   width: 100%;
//   margin-top: ${convertUnit(20)};
// `

export default function GiftShopRobopetActivationIncomplete() {
  const {translate} = useTranslation()
  // const history = useHistory()
  // const {date_of_birth} = useSelector('user') || {}
  const {colorTheme} = useSelector('roboyuState')

  return (
    <GiftShopRobopetActivationTemplate
      backgroundColor="primary_1"
      robopetImg={
        <RoboyuConfused
          width={convertUnit(161)}
          height={convertUnit(174)}
          colorTheme={colorTheme.name}
        />
      }
      title={translate('giftShop:roboyuActivationIncompleteHeader')}
      titleColor="primary_5">
      <Paragraph fontSize="m" fontWeight="medium" color="danger_5">
        {translate('giftShop:roboyuActivationIncompleteDescription')}
      </Paragraph>
      {/* <StyledButton
        label={translate('global:tryAgain')}
        onClick={() => {
          if (
            !!date_of_birth &&
            !validateMinimumAge(date_of_birth, AUTH_USER_MIN_AGE)
          ) {
            history.push('giftshop_robopet_incomplete_child', {
              fromRoboyu: true,
            })
          } else {
            history.push('giftshop_robopet_activation_selfie', {
              isReapply: true,
            })
          }
        }}
      /> */}
    </GiftShopRobopetActivationTemplate>
  )
}
